import { render, staticRenderFns } from "./commonprofilediv.vue?vue&type=template&id=660a8fc4"
import script from "./commonprofilediv.vue?vue&type=script&lang=js"
export * from "./commonprofilediv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports